exports.parse = require('./lib/parse');
exports.stringify = require('./lib/stringify');



//////////////////
// WEBPACK FOOTER
// ./~/jsonify/index.js
// module id = 1463
// module chunks = 0 1 2